import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ErrorType } from 'src/app/enums/error-type.enum';
import endpoints from 'src/app/helpers/endpoints';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';


@Component({
  selector: 'fury-clone-plan-modal',
  templateUrl: './clone-plan-modal.component.html',
  styleUrls: ['./clone-plan-modal.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class ClonePlanModalComponent implements OnInit, OnDestroy {
  clonePlanForm = new FormGroup({
    cloneType: new FormControl('both', [Validators.required]),
    planPropertySizeId: new FormControl(''),
    planPropertyTypeId: new FormControl('')

  });
  ngUnsubscribe  = new Subject<void>();
  constructor(
    public dialogRef: MatDialogRef<ClonePlanModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService
    ) {}

  ngOnInit(): void {
    this.validatePropertyField(this.clonePlanForm.get('cloneType').value);
    this.clonePlanForm.get('cloneType')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: string) => {      
    this.validatePropertyField(res);
    });
  }
  onNoClick() {
    this.dialogRef.close();
  }
  validatePropertyField(res: string){
    const planPropertyTypeId = this.clonePlanForm.get('planPropertyTypeId');
    const planPropertySizeId = this.clonePlanForm.get('planPropertySizeId');
    if(res === 'both'){
      planPropertySizeId.setValidators([Validators.required]);
      planPropertyTypeId.setValidators([Validators.required]);
      planPropertySizeId.updateValueAndValidity();
      planPropertyTypeId.updateValueAndValidity();
    } else if(res === 'propertyType'){
      planPropertyTypeId.setValidators([Validators.required]);
      planPropertyTypeId.updateValueAndValidity();
      planPropertySizeId.clearValidators();
      planPropertySizeId.updateValueAndValidity();

    } else if(res === 'propertySize'){
      planPropertySizeId.setValidators([Validators.required]);
      planPropertySizeId.updateValueAndValidity();
      planPropertyTypeId.clearValidators();
      planPropertyTypeId.updateValueAndValidity();
    }
  }
  clonePlan(){
   if(this.clonePlanForm.valid){
    let payload: any = this.clonePlanForm.value;
    payload.planPriceIds = this.data?.planPriceId;
    if(this.clonePlanForm.value.cloneType === 'propertyType'){
      delete payload.planPropertySizeId;
    }
    if(this.clonePlanForm.value.cloneType === 'propertySize'){
      delete payload.planPropertyTypeId;
    }
    this.apiService.post(endpoints.planManagement.planPrice.clonePlanPrice, payload).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: HttpResponse<any>) => {
        if(res.body){
          this.apiService.alert(res.body?.message, ErrorType.Success);
          this.dialogRef.close(res);
        }
      }, error: (err: HttpErrorResponse) =>{
        this.apiService.alert(err.message, ErrorType.Error);
      }
    })
   } else {
    this.clonePlanForm.markAllAsTouched();
   }
    
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
